import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpEventType,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './auth-module/services/auth.service';
import { catchError, finalize, tap } from "rxjs/operators"
import { AdminService } from './admin/services/admin.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerHandlerService } from './admin/services/spinner.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private spinnerService: SpinnerHandlerService, private adminService: AdminService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinnerService.setDataFound(false);
    this.spinnerService.show()
    // return next.handle(request).pipe(
    //   tap((event: any) => {
    //     debugger
    //     console.log('event', event);

    //     if (event?.type == 401) {
    //       // debugger
    //       console.log('event 401', event);
    //       sessionStorage.clear();
    //       this.router.navigateByUrl('dashboard');
    //     }
    //     if (event?.status == 200) {
    //       // debugger
    //       console.log('event 200', event);
    //     }
    //     // this.authService.showLoader.next(true);
    //     // this.adminService.showLoader.next(true);
    //     // if (event.type == HttpEventType.Response) {
    //     //   if (event.status == 200) {
    //     //     this.authService.showLoader.next(false);
    //     //     //  this.adminService.showLoader.next(false);
    //     //   } else if (event.status == 401) {
    //     //     debugger
    //     //     this.authService.showLoader.next(false);
    //     //     // this.adminService.showLoader.next(false);
    //     //     sessionStorage.clear();
    //     //     this.router.navigateByUrl('dashboard');
    //     //   }
    //     // } else {
    //     //   this.authService.showLoader.next(false);
    //     // }
    //   }),

    //   (err: any) => {
    //     if (err instanceof HttpErrorResponse) {
    //       if (err?.status !== 401) {
    //         return;
    //       }
    //     }
    //   }
    // )

    return next.handle(request).pipe(
      tap(() => { },
        (error: any) => {
          console.log(error);

          if (error instanceof HttpErrorResponse) {
            if (error.status == 401) {
              Swal.fire("Logged out", "You've been logged out, Please try login again", 'error').then(() => {
                sessionStorage.clear();
                this.router.navigateByUrl('/login');
              })
            }
          }
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      }),
      finalize(this.finalize.bind(this)),
    )
  }
  finalize = (): void => {
    this.spinnerService.hide();
    this.spinnerService.setDataFound(true);
  };
}
